module.exports = __webpack_public_path__ + "img/jornay-logo.d06186eb.svg";